import { addDays, mskToday, daysBetween } from './format';

// The selected period lives in the URL (?preset=30 or ?from=&to=) so it survives reloads and is
// carried to the detailed analytics. Dates are Moscow calendar days, same as on the server.

export const PRESETS = [7, 30, 60, 90];
// Data loads automatically from AUTO_HISTORY_FROM; older data is loaded on request.
// WB serves nothing before EARLIEST_DATE, so no period may start earlier.
export const AUTO_HISTORY_FROM = '2026-01-01';
export const EARLIEST_DATE = '2024-01-29';

export function earliestAllowed() {
  return EARLIEST_DATE;
}

export function periodFromSearch(search) {
  const q = new URLSearchParams(search);
  const from = q.get('from');
  const to = q.get('to');
  if (from && to) return { from, to, preset: null };
  const preset = Number(q.get('preset')) || 30;
  return presetPeriod(PRESETS.includes(preset) ? preset : 30);
}

export function presetPeriod(days) {
  const to = mskToday();
  return { from: addDays(to, -(days - 1)), to, preset: days };
}

export function periodQuery(p) {
  return p.preset ? { preset: String(p.preset) } : { from: p.from, to: p.to };
}

export function periodSearch(p, extra = {}) {
  const q = new URLSearchParams({ ...periodQuery(p), ...extra });
  return q.toString();
}

// Returns an error message in Russian, or null when the range is allowed.
export function validateRange(from, to, today = mskToday()) {
  if (!from || !to) return 'Укажите дату начала и дату окончания';
  if (from > to) return 'Дата начала позже даты окончания';
  if (to > today) return 'Нельзя выбрать будущие даты';
  if (from < earliestAllowed()) return 'Wildberries отдаёт данные начиная с 29.01.2024';
  return null;
}

export function periodLength(p) {
  return daysBetween(p.from, p.to);
}
